import useFetch from '@hooks/useFetch';

const usePopularSearches = () => {
  const key = 'v1/search_v3/populars/';
  const { data: popularSearches, ...rest } = useFetch(key);
  return { popularSearches, ...rest };
};

export default usePopularSearches;
